module.exports = __webpack_public_path__ + "static/media/Public_21.a39b0c5e.jpg";